





















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon }
})
export default class FilterTag extends Vue {
  remove () {
    this.$emit('remove')
  }
}
